import React from 'react';
import { Block, Button, Click, Flex, Text, useTheme } from 'vcc-ui';

const testError = () => {
  throw new Error('Testing Sentry');
};

export const Footer = () => {
  const theme = useTheme();
  return (
    <Flex
      as="footer"
      extend={{
        background: theme.color.background.primary,
        padding: '64px 32px',
        alignItems: 'center',
      }}
    >
      <Block extend={{ marginBottom: '50px' }}>
        <Button
          intent="secondary"
          variant="outline"
          onClick={() => {
            window.scrollTo(0, 0);
          }}
        >
          To the top
        </Button>
      </Block>
      <Text variant="bates">
        {new Date().getFullYear()} &copy; Volvo Car Corporation
      </Text>
      <Click
        extend={{ color: theme.color.background.primary }}
        onClick={testError}
      >
        Test
      </Click>
    </Flex>
  );
};
